import { VisiteBody } from "./../domaine/visiteModel";
import axios, { AxiosError, AxiosResponse } from "axios";
import { readToken } from "../services/localStorage.Service";
import { ProjectModel } from "../domaine/projectModel";

const apiUrl = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({
  baseURL: apiUrl,
});

axiosInstance.interceptors.request.use((config: any) => {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${readToken()}`,
  };
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error(
        "HTTP error response:",
        error.response.data || "No response data available"
      );
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("HTTP no response:", error.request);
      return Promise.reject({
        message: "No response received from the server",
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("HTTP request setup error:", error.message);
      return Promise.reject({ message: "Error setting up the request" });
    }
  }
);

export interface AppartmentBody {
    fk_tranche:                number;
    name:                      string;
    type_de_cuisine:           string;
    nbr_de_chambres_min:       number;
    nbr_de_chambres_max:       number;
    nbr_de_salles_de_bain_min: number;
    nbr_de_salles_de_bain_max: number;
    balcon_terasse:            boolean;
    surface_min:               number;
    surface_max:               number;
}

export interface VillaBody {
    fk_tranche:                number;
    name:                      string;
    type_de_cuisine:           string;
    nbr_de_chambres_min:       number;
    nbr_de_chambres_max:       number;
    nbr_de_salles_de_bain_min: number;
    nbr_de_salles_de_bain_max: number;
    balcon_terasse:            boolean;
    surface_terrain_min:       number;
    surface_terrain_max:       number;
    surface_construite_min:    number;
    surface_construite_max:    number;
    sous_sol:                  boolean;
}

export interface LcBody {
    fk_tranche:            number;
    name:                  string;
    hsp:                   number;
    mezzanine:             boolean;
    rdc_surface_min:       number;
    rdc_surface_max:       number;
    sous_sol:              boolean;
    sous_sol_surface_min:  number | null;
    sous_sol_surface_max:  number | null;
    mezzanine_surface_min: number | null;
    mezzanine_surface_max: number | null;
}

export interface BureauxBody {
    fk_tranche:           number;
    name:                 string;
    finition:             string;
    installation_cablage: boolean;
    bureau_surface_min:   number;
    bureau_surface_max:   number;
}

export const addAppartmentsProgrammationsApi = async (
  newProgrammations: AppartmentBody[],
  apiUrl: string
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post<any>(
      apiUrl,
      newProgrammations
    );
    return response.data.ids;
  } catch (error: any) {
    console.error("Add appartments programmations failed", error);
    throw error.response?.data || "Add appartments programmations failed";
  }
};

export const addVillasProgrammationsApi = async (
    newProgrammations: VillaBody[],
    apiUrl: string
  ): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosInstance.post<any>(
        apiUrl,
        newProgrammations
      );
      return response.data.ids;
    } catch (error: any) {
      console.error("Add villas programmations failed", error);
      throw error.response?.data || "Add villas programmations failed";
    }
  };

  export const addLcProgrammationsApi = async (
    newProgrammations: LcBody[],
    apiUrl: string
  ): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosInstance.post<any>(
        apiUrl,
        newProgrammations
      );
      return response.data.ids;
    } catch (error: any) {
      console.error("Add locaux commerciaux programmations failed", error);
      throw error.response?.data || "Add locaux commerciaux programmations failed";
    }
  };


  export const addBureauxProgrammationsApi = async (
    newProgrammations: BureauxBody[],
    apiUrl: string
  ): Promise<any> => {
    try {
      const response: AxiosResponse<any> = await axiosInstance.post<any>(
        apiUrl,
        newProgrammations
      );
      return response.data.ids;
    } catch (error: any) {
      console.error("Add bureaux programmations failed", error);
      throw error.response?.data || "Add bureaux programmations failed";
    }
  };
  

